import React, { useState } from 'react';
import { Collapse, CardBody } from 'reactstrap';
import { CardHeader, Button, Form, Field } from '@cordata/buffet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Yup from 'yup';

import {
  authorizedInstance as axios,
  authorizedPyPublicInstance as Public,
  authorizedInstanceNoBase as full,
} from '~/utils';

const initialValues = {
  body: '',
  subject: '',
};

const validationSchema = Yup.object().shape({
  body: Yup.string().required(),
  subject: Yup.string().required(),
});

const CategoryListHeader = () => {
  const [open, setOpen] = useState(false);
  const [patients, setPatients] = useState([]);

  const toggleCollapse = () => setOpen(!open);
  const fetchPatients = () =>
    axios
      .get('summary-patients')
      .then(r => r.data.data)
      .then(setPatients);

  return (
    <>
      <CardHeader
        action={
          <Button
            outline
            size="sm"
            onClick={toggleCollapse}
          >
            <FontAwesomeIcon icon="plus" />
            <span className="d-none d-md-inline ml-2">Start a Conversation</span>
          </Button>
        }
      >
        <strong>Conversations</strong>
      </CardHeader>

      <Collapse
        isOpen={open}
        onEntering={fetchPatients}
      >
        <Form
          displayName="AddSubscription"

          initialValues={initialValues}
          validationSchema={validationSchema}

          onSubmit={(values, {
            setErrors, setSubmitting,
          }) =>
            Public
              .post(`patient/${values.subject.id}/chat`, { body: values.body })
              .then(r => r.data.data)
              .then(r => full
                .get(r.relationships.realTimeTopic.related))
              .then(r => r.data.data)
              .then(r => full
                .get(r.relationships.realTimeSubscriptions.related))
              .then(r => r.data.data)
              .then((r) => { window.location.replace(`/chat?s=${r[0].id}`); })
              .catch(setErrors)
              .then(() =>
                setSubmitting(false))
          }
        >
          {({
            isSubmitting,
          }) => (
            <CardBody>
              <Field
                name="subject"
                type="select"
                options={patients}
                required
                getOptionValue={o => o.id}
                getOptionLabel={o => `${o.attributes.lastName}, ${o.attributes.firstName}`}
              />

              <Field
                name="body"
                type="textarea"
                required
              />

              <Button block disabled={isSubmitting} type="submit">
                Send{isSubmitting && 'ing ...'}
              </Button>
            </CardBody>
          )}
        </Form>
      </Collapse>
    </>
  );
};

export default CategoryListHeader;
